<template>
  <div class="notice">
    <div>
      <el-button type="primary" plain @click="batchReaded" class="h40 clear" :disabled="tabActive !== '0'"> {{$lang('全部标为已读')}}</el-button>
    </div>
    <div class="searchParam">
      <el-select v-model="searchParam.value" :placeholder="$lang('请选择')">
        <el-option v-for="item in searchParam.payment" :key="item.code" :label="$lang(item.name)" :value="item.code"> </el-option>
      </el-select>
      <el-input v-model="searchParam.titleKey" :placeholder="$lang('请输入标题关键字进行搜索')" maxlength="15" style="margin:0 24px;width:170px !important"></el-input>
      <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{$lang('查询')}} </el-button>
              <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{$lang('清空')}}</el-button>
    </div>
    <div>
      <div class="notice-bottom">
        <div class="notice-nav">
          <div class="notice-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(item.timelyNum)" :class="{ active: tabActive === item.timelyNum }">
            {{ $lang(item.name) }}<span class="notice-nav-item-count">{{ item.timely }}</span>
          </div>
        </div>
        <JmsTable :option="listOpt" :data="tableList" :page="page" :table-loading="loading" @selection-change="selectionChange"  @current-change="currentChange"
      @size-change="sizeChange">
          <template slot="type" slot-scope="data">
            <div class="notice-label"> {{data.row.type === 1 ? $lang('紧急公告') : data.row.type === 2 ? $lang('上线公告') : $lang('业务公告')}}
            </div>
          </template>
          <template slot="title" slot-scope="data">
            <div class="notice-label notice-pointer"  @click="openNotice(data.row)">
              <span class="notice-top" v-if="parseInt(data.row.noticeLevel) === 1">{{$lang('置顶')}}</span>
              <span class="notice-mustRead" v-else-if="parseInt(data.row.noticeLevel) === 2">{{$lang('必读')}}</span>
              <span class="notice-major" v-else-if="parseInt(data.row.noticeLevel) === 3">{{$lang('重要')}}</span>
              <span class="notice-ordinary" v-else-if="parseInt(data.row.noticeLevel) === 4">{{$lang('普通')}}</span>
              {{ data.row.title }}
            </div>
          </template>
        </JmsTable>
      </div>
    </div>
    <!-- 公告弹框 -->
    <noticeDialog
      :visible.sync="dialogVisible"
      :showClose="showClose"
      :page="page"
      :noticeContent="noticeContent"
      @updateVisible="updateVisible"
      @Read="readNotice"
      @handleClose="handleClose"
      :popupWidth="'920px'"
      ref="noticeDialog"
    >
    </noticeDialog>
  </div>
</template>

<script>
import noticeDialog from '@components/dialog/noticeDialog'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { noticeList, noticeStatus, noticeReaded, noticeDetail } from '@api/module/customer'
import { mapActions } from 'vuex'
export default {
  name: 'Notice',
  mixins: [mixin],
  components: {
    noticeDialog,
    JmsTable,
  },
  data() {
    return {
      dialogVisible: false,
      selection: [],
      showClose: false,
      tabActive: '0',
      noticeContent: {},
      COM_HTTP: {
        reqList: noticeList,
        noticeStatus: noticeStatus, // 获取已读未读
        noticeReaded: noticeReaded, // 已阅读
        noticeDetail: noticeDetail, // 详情
      },
      menuItems: [{ name: '未读', timely: '0', timelyNum: '0' }, { name: '已读', timely: '0', timelyNum: '1' }],
      searchParam: {
        value: '0',
        titleKey: '',
        payment: [
          {
            code: '0',
            name: '全部',
          },
          {
            code: '1',
            name: '紧急公告',
          },
          {
            code: '2',
            name: '上线公告',
          },
          {
            code: '3',
            name: '业务公告',
          },
        ],
      },
    }
  },
  async created() {
    await this.getGroupCount()
  },
  computed: {
    isNoticeNum() {
      return this.$store.state.base.noticeUnread
    },
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: false,
        fixHeight: 220,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '类型',
            prop: 'type',
            slot: true,
            width: 200,
          },
          {
            label: '主题',
            slot: true,
            prop: 'title',
          },
          {
            label: '发布时间',
            prop: 'onlineTime',
            width: 340,
          },
        ],
      }
    },
  },
  watch: {
    isNoticeNum(value) {
      if (value) {
        this.searchFun()
        this.getGroupCount()
      }
    },
  },
  methods: {
    ...mapActions(['NOTICE_UNREAD']),
    //  获取未读已读
    async getGroupCount() {
      const params = {
        pushPlatform: 2,
        type: this.searchParam.value,
        title: this.searchParam.titleKey,
      }
      const { code, data } = await noticeStatus(params)
      if (code === 1) {
        this.menuItems[1].timely = parseInt(data.readedCount)
        this.menuItems[0].timely = parseInt(data.unReadCount)
        if (this.searchParam.value === '0' && this.searchParam.titleKey === '') {
          this.NOTICE_UNREAD(parseInt(data.unReadCount))
        }
      }
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.getGroupCount()
      this.selection = []
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.getGroupCount()
      this.selection = []
    },
    // 批量已读
    batchReaded() {
      if (this.selection.length >= 1) {
        const noticeIds = []
        this.selection.forEach(item => {
          if (item.isRead === '1') {
            this.$message.error(this.$lang('勾选中有已阅读的公告，请重新勾选'))
            return
          } else {
            noticeIds.push(item.id)
          }
        })
        const params = {
          noticeIds: noticeIds,
        }
        this.goReaded(params)
      } else {
        this.$message.error(this.$lang('请勾选想要阅读的公告'))
      }
    },
    // 打开公告弹窗
    openNotice(value) {
      // 是否强制打开
      console.log(value)
      this.getNotContent(value.id)
      if (value.isRead === '0') {
        this.showClose = false
        this.$nextTick(() => {
          this.$refs.noticeDialog && this.$refs.noticeDialog.startCountdown()
        })
      } else {
        this.showClose = true
      }
      this.noticeContent = value
      this.dialogVisible = true
    },
    async getNotContent(id) {
      const params = {
        id: id,
      }
      const { code, data } = await noticeDetail(params)
      if (code === 1) {
        this.noticeContent.content = data.content
        this.noticeContent.fileUrl = data.fileUrl
        this.noticeContent.downloadUrl = data.downloadUrl
      }
    },
    getParams() {
      return {
        type: this.searchParam.value,
        title: this.searchParam.titleKey,
        isRead: this.tabActive,
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam.value = '0'
      this.searchParam.titleKey = ''
    },

    // 表格复选框选择回调
    selectionChange(val) {
      this.selection = val
      console.log(this.selection)
    },
    // tab 点击
    changeTab(index) {
      this.tabActive = index
      this.page.current = 1
      this.searchFun()
      this.getGroupCount()
    },
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.dialogVisible = val
    },
    // 已阅读 的事件
    readNotice() {
      if (this.noticeContent.isRead === '0') {
        const noticeIds = []
        noticeIds.push(this.noticeContent.id)
        const params = {
          noticeIds: noticeIds,
        }
        this.goReaded(params)
      } else {
        this.dialogVisible = false
      }
    },
    //  已读回调
    async goReaded(params) {
      const { code } = await noticeReaded(params)
      if (code === 1) {
        this.dialogVisible = false
        const noticeUnread = this.$store.state.base.noticeUnread
        this.NOTICE_UNREAD(parseInt(noticeUnread) - parseInt(params.noticeIds.length))
        if (this.searchParam.value === '0' && this.searchParam.titleKey === '') {
          this.searchFun()
          this.getGroupCount()
        }
      }
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.dialogVisible = false
    },
    // 查询
    searchChange() {
      this.searchFun()
      this.getGroupCount()
    },
  },
}
</script>
<style lang="scss" scoped>
.notice {
  padding: 24px;
}
.notice-title {
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-weight: SC;
  opacity: 1;
}
.searchParam {
  margin: 16px 0 24px;
}
.notice-pointer{
  cursor: pointer;
}
.notice-label {
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    display: inline-block;
    border-radius: 10px;
    padding: 0 15px;
    height: 20px;
    opacity: 1;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  .notice-top {
    background: rgba(230, 0, 18, 0.1);
    color: #e60012;
  }
  .notice-mustRead {
    border: 1px solid rgba(230, 0, 18, 0.2);
    color: #e60012;
  }
  .notice-major {
    color: #fa8b14;
    border: 1px solid rgba(250, 139, 20, 0.2);
  }
  .notice-ordinary {
    color: #999999;

    border: 1px solid #eeeeee;
  }
}
.notice {
  .notice-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }
  .notice-nav {
    //   margin: 9px 0;
    .notice-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .notice-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
